import type { ReactNode } from 'react'
import styles from './JobContent.module.css'

export interface JobContentProps {
  notifications: ReactNode
  overlay: ReactNode
  children: ReactNode
  rail?: ReactNode
  dialogs: ReactNode
}

/**
 * One readable column: who the job is for, where it stands, then the current
 * section; the properties rail opens beside it.
 */
export function JobContent({
  notifications,
  overlay,
  children,
  rail,
  dialogs,
}: JobContentProps) {
  return (
    <div className={styles.root}>
      {notifications}
      {overlay}
      <div className={styles.body}>
        <div className={styles.main} data-test="job-main">
          <div className={styles.column}>{children}</div>
        </div>
        {rail}
      </div>
      {dialogs}
    </div>
  )
}
